import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { ArchiveBundleDialog } from '@/features/admin/bundle/ArchiveBundleDialog'
import { type ArchiveBundleDialogViewModel } from './ArchiveBundleDialogViewModel'

export interface ArchiveBundleDialogContainerProps {
  vm: ArchiveBundleDialogViewModel
}

export const ArchiveBundleDialogContainer = observer(
  function ArchiveBundleDialogContainer({
    vm,
  }: ArchiveBundleDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))

    return (
      <ArchiveBundleDialog
        showing={vm.modal.showing}
        onClose={vm.cancel}
        onArchive={vm.archive}
        isArchivePending={vm.archive.pending}
        bundleName={vm.bundle.name}
        corporateMode={shellInfo.corporateMode}
        testId="bundle"
      />
    )
  },
)
